import { z } from "zod";

// ---------------------------------------------------------------------------
// The only part of the story preparation contract the chat needs at startup:
// the `story_preparation_ready` SSE event and the `story_preparation` field of
// the assistant metadata (the card the turn leaves behind). It is imported by
// eager chat code, so it stays tiny: the full schemas, the API client and the
// attachment helpers live in `./story-preparations` and its siblings, which are
// reached only from the lazy story-preparation routes and the lazily loaded
// `StoryPreparationCard`. The entry chunk sits near the workbox cap
// (`scripts/check-chunk-budget.mjs`): never import those from eager code.
// ---------------------------------------------------------------------------

export const PREPARATION_STATES = [
  "draft",
  "ready_for_review",
  "applying",
  "applied",
  "conflict",
  "failed",
  "outcome_unknown",
  "cancelled",
] as const;
export type PreparationState = (typeof PREPARATION_STATES)[number];
export const preparationStateSchema = z.enum(PREPARATION_STATES);

export const operationSchema = z.enum(["create", "update"]);
export type Operation = z.infer<typeof operationSchema>;

export const storyPreparationRefSchema = z
  .object({
    preparation_id: z.guid(),
    revision_number: z.number().int().positive(),
    state: preparationStateSchema,
    title: z.string(),
    operation: operationSchema,
    target_story_public_id: z.number().int().positive().nullable(),
  })
  .strict();
export type StoryPreparationRef = z.infer<typeof storyPreparationRefSchema>;
